// extracted by mini-css-extract-plugin
module.exports = {"container":"NoSubscriptionsContainer_container__ekjFd","text":"NoSubscriptionsContainer_text__ysLM9"};